import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import MentionView from "../views/MentionView.vue";
import TestimonialView from "../views/TestimonialView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Wanview - Accueil",
    },
  },
  {
    path: "/mention",
    name: "mention",
    component: MentionView,
    meta: {
      title: "Wanview - Mentions légales",
    },
  },
  {
    path: "/testimonial",
    name: "testimonial",
    component: TestimonialView,
    meta: {
      title: "Wanview - Témoignage",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: HomeView,
    meta: {
      title: "Wanview - Accueil",
    },
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }
  window.scrollTo(0, 0);
  next();
});

export default router;
